export default __webpack_public_path__ + "static/media/step2a.ca346faa.png";